// extracted by mini-css-extract-plugin
module.exports = {"text":"Text_text__3S-Qr","fontFamilyAvenir":"Text_fontFamilyAvenir__2_8d6","fontFamilyLato":"Text_fontFamilyLato__1LWYb"};